module.exports = __webpack_public_path__ + "static/media/loader.05bfeed5.gif";